import { Outlet, useResolvedPath } from "react-router";
import UserGrid from "../../components/DataGrid/UserGrid";

export default function User() {
  const path = useResolvedPath();
  return (
    <main style={{ height: path.pathname.includes("/user/") && "fit-content" }}>
      <Outlet />
    </main>
  );
}
